export default __webpack_public_path__ + "790597e475386f7d5835782e8cc22e92.svg";